<app-select-ejecucion-informes *ngIf="isPageEnabled"></app-select-ejecucion-informes>
<app-not-implemented *ngIf="!isPageEnabled"></app-not-implemented>
